import { Component, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CargoListComponent } from '../cargo-list/cargo-list.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { AuthService } from 'src/app/core/services/authentication.service';
import { environment } from 'src/environments/environment';
import { Permission } from 'src/app/core/resources/permission';
@Component({
  selector: 'app-cargo-list-expenses-income',
  templateUrl: './cargo-list-expenses-income.component.html',
  styleUrls: ['./cargo-list-expenses-income.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CargoListExpensesIncomeComponent implements OnInit {
  private static openedModalUncared: boolean = false;
  @ViewChildren(CargoListComponent) cargoList: QueryList<CargoListComponent>;
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;
  selectedTab: number = 0;
  permission = Permission;
  activeTab: string = 'Comprobante Contable';
  constructor(
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    if (!this.showListWithoutPayments) this.activeTab = 'Egresos';
  }

  onSelectTab($event: number) {
    this.activeTab = this.tabGroup && this.tabGroup._tabs && this.tabGroup._tabs.toArray()[$event] && this.tabGroup._tabs.toArray()[$event].textLabel ? this.tabGroup._tabs.toArray()[$event].textLabel : '';
    if (this.activeTab && this.activeTab === 'Egresos') sessionStorage.setItem('_activeTab', 'expenses');
    else sessionStorage.setItem('_activeTab', 'withoutPayment')
    //this.cargoList.toArray()[$event].cargoListFilterComponent.ngAfterViewInit();
  }

  resetFilters($event: boolean) {
    //this.cargoList.toArray().forEach(list => list.cargoListFilterComponent.cleanFilter())
  }

  get showListWithoutPayments() {
    return this.authService && this.authService.getUserSession().clientCompanyId === environment.rootNit
  }

  get listPermissions() {
    if (this.showListWithoutPayments) {
      return [this.permission.payments.generateJournalCargo, this.permission.payments.generateAccountingFiles];
    }
    return [this.permission.payments.generateAccountingFiles];
  }

}
